import { render } from "./HeroBar.vue?vue&type=template&id=fbbdbdc0"
import script from "./HeroBar.vue?vue&type=script&lang=js"
export * from "./HeroBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__